import { defineComponent as _defineComponent } from 'vue'
import { useTranslation } from '@/store/translation';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollingText',
  props: {
    text: { default: "" }
  },
  setup(__props: any) {

const props = __props as { text: string };

const { $t } = useTranslation();



const duration = computed(() => Math.max(20, props.text.length * 0.5));

return { __sfc: true,$t, props, duration }
}

})